export enum DisplayType {
  NAME = "name",
  BOTH = "both",
  AVATAR = "avatar",
}
